<tr class="total two-columns-group-sticky">
  <td class="col-first-level"></td>
  <td class="col-second-level" colspan="3">Total capital required</td>
  <td class="blank-space col-fifth-level"></td>
  @for (data of budgetFormValue$$().modelData.totalCapRequired.values; track data) {
    <td
      [attr.data-qa]="'bm-total-cap-req-'+ data.period.quarterNumber + '-' + data.period.yearNumber"
      class="bold600"
      [class.bg-black-3]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
      [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
      {{data.itemValue | switcherDashBraces : 1 : 0}}
    </td>
    @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td [class.bg-black-3]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
  <td class="fix-w-0p25 blank-space right-sticky right-[5.5rem]"></td>
  <td class="fix-w-5p5 right-sticky right-0">
    <div class="flex flex-col">
      <span [attr.data-qa]="'bm-total-cap-req-row'" class="bold600">
        {{ budgetFormValue$$().modelData.totalCapRequired.totalRow | switcherDashBraces : 1 : 0}}
      </span>
      <span [attr.data-qa]="'bm-total-cap-req-row-pcnt'" class="caption-3 black-9">
        {{budgetFormValue$$().modelData.totalCapRequired.totalRowPcnt | switcherDashBraces : 1 : 1: false : '' : '%' }}
      </span>
    </div>
  </td>
</tr>
<tr class="total two-columns-group-sticky">
  <td class="col-first-level"></td>
  <td class="col-second-level" colspan="3">Total capital required, %</td>
  <td class="blank-space col-fifth-level"></td>
  @for (data of budgetFormValue$$().modelData.totalCapRequired.pcnt; track data) {
    <td
      [attr.data-qa]="'bm-total-cap-req-pcnt-'+ data.period.quarterNumber + '-' + data.period.yearNumber"
      class="bold600"
      [class.bg-black-3]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
      [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
      {{data.itemValue | switcherDashBraces : 1 : 1: false : '' : '%' }}
    </td>
    @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td [class.bg-black-3]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
  <td class="fix-w-0p25 blank-space right-sticky right-[5.5rem]"></td>
  <td class="fix-w-5p5 right-sticky right-0">
    <div class="flex flex-col">
      <span data-qa="bm-total-cap-req-pcnt-row" class="bold600">{{ budgetForm().controls.modelData.controls.totalCapAccumulated.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%'}}</span>
      <span class="caption-3 black-9"></span>
    </div>
  </td>
</tr>
<tr class="blank-row two-columns-group-sticky">
  <td class="col-first-level"></td>
  <td class="col-second-level" colspan="3"></td>
  <td class="blank-space col-fifth-level"></td>
  @for (header of budgetFormValue$$().modelHeaders; track header; let last = $last) {
    @if (header.type === BmPeriodEnum.QUARTER) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed || collapsedYears().get(header.yearNumber)">
      </td>
    }
    @if (header.type === BmPeriodEnum.YEAR && !last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed || collapsedYears().get(header.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td></td>
  <td class="blank-space right-sticky right-[5.5rem]"></td>
  <td class="right-sticky right-0"></td>
</tr>
<tr class="total two-columns-group-sticky">
  <td class="col-first-level"></td>
  <td class="col-second-level" colspan="3">Accumulated capital required</td>
  <td class="blank-space col-fifth-level"></td>
  @for (data of budgetFormValue$$().modelData.totalCapAccumulated.values; track data) {
    <td
      [attr.data-qa]="'bm-total-acc-req-'+ data.period.quarterNumber + '-' + data.period.yearNumber"
      class="bold600"
      [class.bg-black-3]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
      [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
      {{data.itemValue | switcherDashBraces : 1 : 0}}
    </td>
    @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td [class.bg-black-3]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
  <td class="fix-w-0p25 blank-space right-sticky right-[5.5rem]"></td>
  <td class="fix-w-5p5 right-sticky right-0">
    <div class="flex flex-col">
      <span data-qa="bm-total-acc-req-row" class="bold600">{{ budgetFormValue$$().modelData.totalCapAccumulated.totalRow | switcherDashBraces : 1 : 0}}</span>
      <span class="caption-3 black-9 bold600"></span>
    </div>
  </td>
</tr>
<tr class="total two-columns-group-sticky">
  <td class="col-first-level"></td>
  <td class="col-second-level" colspan="3">Accumulated capital required, %</td>
  <td class="blank-space col-fifth-level"></td>
  @for (data of budgetFormValue$$().modelData.totalCapAccumulated.pcnt; track data) {
    <td
      [attr.data-qa]="'bm-total-acc-req-pcnt-'+ data.period.quarterNumber + '-' + data.period.yearNumber"
      class="bold600"
      [class.bg-black-3]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
      [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
      {{data.itemValue | switcherDashBraces : 1 : 1: false : '' : '%'}}
    </td>
    @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td [class.bg-black-3]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
  <td class="fix-w-0p25 blank-space right-sticky right-[5.5rem]"></td>
  <td class="fix-w-5p5 right-sticky right-0">
    <div class="flex flex-col">
      <span data-qa="bm-total-acc-req-row">{{ budgetFormValue$$().modelData.totalCapAccumulated.totalRowPcnt | switcherDashBraces : 1 : 1: false : '' : '%'}}</span>
      <span class="caption-3 black-9"></span>
    </div>
  </td>
</tr>
